/// <reference path="./vite-env.d.ts" />
import { isDesktop } from '@coderly/desktop-bridge';

function isFlagEnabled(key: string): boolean {
  try {
    return globalThis.localStorage?.getItem(key) === '1';
  } catch {
    return false;
  }
}

function shouldEnableReactScan(): boolean {
  if (!import.meta.env.DEV) {
    return false;
  }

  if (!isFlagEnabled('coderly.reactScan')) {
    return false;
  }

  if (!isDesktop()) {
    return true;
  }

  return isFlagEnabled('coderly.reactScan.desktop');
}

if (shouldEnableReactScan()) {
  await import('./reactScan');
}

await import('./bootstrap');
